export default __webpack_public_path__ + "static/media/loc_img_9.ea11ec8e.jpg";